"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _it_IT = _interopRequireDefault(require("../locale/it_IT"));
var _default = exports["default"] = _it_IT["default"];